export default {
    portfolio: {
        title: 'Portfolio',
        setRefreshTimeSuccessMessage: 'Refresh time updated',
        setRefreshTimeErrorMessage:
            'Something went wrong when update refresh time',
        updateWatchlistSuccessMessage: 'Portfolio config successfully updated',
        updateFieldsSuccessMessage: 'Portfolio fields successfully updated',
        newPositionSuccessMessage: 'Position updated',
        fieldsDictionary: {
            netPosition: {
                name: 'Net Position',
            },
            pnlPrice: {
                name: 'PNL Price',
                type: 'multiply',
            },
            pnl: {
                name: 'PNL',
            },
            avgBuy: {
                name: 'AVG Buy',
                type: 'multiply',
            },
            name: {
                name: 'Name',
            },
            alias: {
                name: 'Alias',
            },
            lastTradeDate: {
                name: 'Last Trade Date',
                type: 'date',
            },
        },
    },
};
